<!-- <style>

.k-window:not(.k-window-maximized) #StiDesigner
{
height: calc(100vh) !important;

}
.k-window-maximized #StiDesigner{
height: calc(100vh) !important;

}

</style>
<kendo-window #mainWindow class="fullWidthFormForm"  *ngIf="_active" (close)="_closeForm()" (stateChange)="_onStateChanges($event)">

  <div id="designer"></div>

  <style>
    .k-window.fullWidthFormForm, .k-window.fullWidthFormForm
    {
    height: unset !important;
  }
  .k-window-maximized #StiDesigner{
  height: 961px !important;
}
</style> -->
<style>
  #StiDesigner{
  height: calc(100vh) !important;
}
</style>
@if (_active) {
  <kendo-window #mainWindow class="fullWidthFormForm"  (close)="_closeForm()" (stateChange)="_onStateChanges($event)">
    <div class="fullWidthFormForm" id="designer"></div>
  </kendo-window>
}
